import { createContext, ReactNode, useContext, useMemo } from "react";
import { AdressesFavoritesService } from "../services/adresses-favorites-service";
import { ApprobationEntrepriseService } from "../services/approbation-entreprise-service";
import { ClientService } from "../services/client-service";
import { VehicleService } from "../services/vehicle-service";
import { DriverService } from "../services/driver-service";
import { EntrepriseService } from "../services/entreprise-service";
import { InvitationEntrepriseService } from "../services/invitation-entreprise-service";
import { CourseService } from "../services/course-service";
import { UserService } from "../services/user-service";
import { ContactService } from "../services/contact-service";

type ServiceKmsContextType = {
  userService: UserService;
  adressesFavoritesService: AdressesFavoritesService;
  approbationEntrepriseService: ApprobationEntrepriseService;
  clientService: ClientService;
  driverService: DriverService;
  entrepriseService: EntrepriseService;
  invitationEntrepriseService: InvitationEntrepriseService;
  courseService: CourseService;
  vehicleService: VehicleService;
  contactService: ContactService;
};

const KmsServiceContext = createContext<ServiceKmsContextType | null>(null);

const apiUrl = "/backend-api";

export const KmsServiceProvider = ({ children }: { children: ReactNode }) => {
  // L'authentification est portée par le cookie HttpOnly `keycloak-token`,
  // envoyé automatiquement aux appels same-origin vers /backend-api. Le proxy
  // serveur y injecte l'en-tête Authorization ; les services n'ont donc plus
  // besoin de l'access token.
  const services = useMemo(
    () => ({
      userService: new UserService(apiUrl),
      adressesFavoritesService: new AdressesFavoritesService(apiUrl),
      approbationEntrepriseService: new ApprobationEntrepriseService(apiUrl),
      clientService: new ClientService(apiUrl),
      driverService: new DriverService(apiUrl),
      entrepriseService: new EntrepriseService(apiUrl),
      invitationEntrepriseService: new InvitationEntrepriseService(apiUrl),
      courseService: new CourseService(apiUrl),
      vehicleService: new VehicleService(apiUrl),
      contactService: new ContactService(apiUrl),
    }),
    [],
  );

  return (
    <KmsServiceContext.Provider value={services}>
      {children}
    </KmsServiceContext.Provider>
  );
};

export const useKmsService = () => {
  const services = useContext(KmsServiceContext);

  if (!services) {
    throw new Error("useIoService must be used within ServiceElectronProvider");
  }

  return services;
};

export const useCourse = () => useKmsService().courseService;
